import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { invitationsApi } from '../api/invitationsApi';
import type { InvitationDetails } from '../types/sp-client-management.types';

export function useInvitationDetails(
  token: string
): UseQueryResult<InvitationDetails, Error> {
  return useQuery({
    queryKey: ['sp-invitation', token],
    queryFn: () => invitationsApi.getByToken(token),
    enabled: Boolean(token), // Only fetch if token is provided
    staleTime: 0, // Always fetch fresh data for invitation status
    retry: false, // Don't retry on 404
  });
}
